export const loadBillingSummary = async (request, setSummary, setBusy) => {
    if (!request) return;
    if (setBusy) setBusy(true);
    try {
        const data = await request('/api/v1/billing/summary', {});
        setSummary(data);
    } finally {
        if (setBusy) setBusy(false);
    }
};

export const loadBillingTransactions = async (request, setTransactions, setBusy) => {
    if (!request) return;
    if (setBusy) setBusy(true);
    try {
        const data = await request('/api/v1/billing/transactions', {});
        setTransactions(data || []);
    } finally {
        if (setBusy) setBusy(false);
    }
};

export const createTopup = async (request, payload) => {
    return await request('/api/v1/billing/topup', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};
